import { dataHook, prefix } from '../../utils'
import { TranslateFn } from '../../types'
import { primaryButtonTemplate } from '../button'
import { createToggleTemplate } from '../toggle'
import { closeButtonTemplate } from '../close-button'
// @ts-ignore
import classes from './modal.css'

export const MODAL_HOOK = 'modal'
export const MODAL_SAVE_HOOK = 'modal-save'
export const MODAL_CLOSE_HOOK = 'modal-close'
export const MODAL_TITLE_HOOK = 'modal-title'
export const MODAL_CONTENT = 'modal-content'
export const MODAL_SECTION_1_TITLE_HOOK = 'modal-s1-title'
export const MODAL_SECTION_1_TEXT_HOOK = 'modal-s1-text'
export const MODAL_SECTION_2_TITLE_HOOK = 'modal-s2-title'
export const MODAL_SECTION_2_TEXT_HOOK = 'modal-s2-text'
export const MODAL_RECOMMENDED_CHECKBOX_HOOK = 'modal-recommended-checkbox'
export const MODAL_RECOMMENDED_CHECKBOX_LABEL_HOOK =
  'modal-recommended-checkbox-label'

export const createModalTemplate = (t: TranslateFn) =>
  `<div class=${classes.modal} ${dataHook(
    MODAL_HOOK,
  )} role="dialog" aria-labelledby="${prefix(
    MODAL_TITLE_HOOK,
  )}" aria-describedby="${prefix(MODAL_CONTENT)}">
  <section class="${classes.body}" tabindex="-1">
    <h2 id="${prefix(MODAL_TITLE_HOOK)}" class="${classes.head}" ${dataHook(
    MODAL_TITLE_HOOK,
  )}>${t('CookieConsentBanner_AdvancedSettings_Title')}</h2>
    <section id="${prefix(MODAL_CONTENT)}" class="${
    classes.content
  }" ${dataHook(MODAL_CONTENT)} aria-label="${t(
    'CookieConsentBanner_ModalContentAriaLabel',
  )}">
      <section class="${classes.section}">
        <div class="${classes.section_title}" ${dataHook(
    MODAL_SECTION_1_TITLE_HOOK,
  )}>${t('CookieConsentBanner_AdvancedSettings_EssentialCookies_Title')}</div>
        <p class="${classes.section_text}" ${dataHook(
    MODAL_SECTION_1_TEXT_HOOK,
  )}>${t('CookieConsentBanner_AdvancedSettings_EssentialCookies_Text')}</p>
      </section>
      <section class="${classes.section}">
        <div id="${prefix(MODAL_SECTION_2_TITLE_HOOK)}" class="${
    classes.section_title
  }" ${dataHook(MODAL_SECTION_2_TITLE_HOOK)}>${t(
    'CookieConsentBanner_AdvancedSettings_RecommendedCookies_Title',
  )}</div>
        <p class="${classes.section_text}" ${dataHook(
    MODAL_SECTION_2_TEXT_HOOK,
  )}>${t('CookieConsentBanner_AdvancedSettings_RecommendedCookies_Text')}</p>
        ${createToggleTemplate(
          classes.toggle,
          MODAL_RECOMMENDED_CHECKBOX_HOOK,
          MODAL_RECOMMENDED_CHECKBOX_LABEL_HOOK,
          undefined,
          `aria-labelledby="${prefix(MODAL_SECTION_2_TITLE_HOOK)}"`,
        )}
      </section>
    </section>
    <footer class="${classes.foot}">
      ${primaryButtonTemplate(
        t('CookieConsentBanner_AdvancedSettings_SaveButton_Label'),
        MODAL_SAVE_HOOK,
      )}
      ${closeButtonTemplate(MODAL_CLOSE_HOOK, classes.close)}
    </footer>
  </section>
</div>`
